import './ProfilePosts.styles.scss';
import { Avatar, Link, Typography } from '@material-ui/core';
import { Link as RouterLink, useParams } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { BulletList } from 'react-content-loader';
import MyThemeContext from '../../../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../../../utils/pickBkgClass';
import pickSkeletonColor from '../../../utils/pickSkeletonColor';
import Axios from 'axios';
const ProfilePosts = ({ fetchedUser }) => {
	const { themeName, themeType } = useContext(MyThemeContext);
	const { username } = useParams();

	const [fetchingPosts, setFetchingPosts] = useState(true);
	const [fetchedPosts, setFetchedPosts] = useState([]);

	const sleep = ms => new Promise(r => setTimeout(r, ms));
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		if (fetchedUser.profileUsername) {
			const fetchUserPosts = async () => {
				setFetchingPosts(true);
				setFetchedPosts([]);
				await sleep(400);
				try {
					const response = await Axios.get(
						`/profile/${fetchedUser.profileUsername}/posts`,
						{
							cancelToken: cancelTokenSource.token
						}
					);
					console.log('Fetched user posts', response);
					setFetchingPosts(false);
					setFetchedPosts(response.data);
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			fetchUserPosts();
		}
		// cleanup
		return () => {
			cancelTokenSource.cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchedUser.profileUsername, username]);

	const renderPosts = () => {
		if (fetchedPosts.length > 0 && !fetchingPosts) {
			return (
				<div
					className={`profilePosts profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					{fetchedPosts.map(({ _id, title, author, createdDate }) => (
						<div className={`postBrief ${themeType}`} key={_id}>
							<Avatar src={author.avatar ? author.avatar : null} />
							<div className="title_date">
								<Link
									className="postTitle"
									color="primary"
									component={RouterLink}
									to={`/post/${_id}`}
								>
									{title}
								</Link>
								<Typography variant="body2" className="postdate">
									{moment(createdDate).fromNow()}
								</Typography>
							</div>
						</div>
					))}
				</div>
			);
		} else if (fetchedPosts.length === 0 && fetchingPosts) {
			return <BulletList width="50vw" {...pickSkeletonColor(themeName)} />;
		} else if (fetchedPosts.length === 0 && !fetchingPosts) {
			return (
				<div
					className={`profilePosts profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					No Posts
				</div>
			);
		}
	};

	return renderPosts();
};

export default ProfilePosts;
